import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { PrismSelectInput } from '@mylighthouse/prism-ember';
import type { Option } from '@mylighthouse/prism-ember/components/prism/select-input';
import {
  type AccessRight,
  ROLE_OPTIONS_MAP,
} from 'lumen/utils/constants/users-constants';

import styles from './cell-role.module.css';

interface SettingsUsersTablesCellsCellRoleSignature {
  Args: {
    cellData: AccessRight;
    row: {
      isDisabled?: boolean;
      onRoleChange?: (role: AccessRight) => void;
    };
  };
}

export default class CellRole extends Component<SettingsUsersTablesCellsCellRoleSignature> {
  @service declare intl: Services['intl'];

  @tracked localRole: AccessRight | undefined;

  get currentRole(): AccessRight {
    return this.localRole ?? this.args.cellData;
  }

  get options(): Option[] {
    return Object.entries(ROLE_OPTIONS_MAP).map(([key, translationKey]) => ({
      key,
      label: this.intl.t(translationKey),
    }));
  }

  get selectedOption(): Option | undefined {
    return this.options.find((option) => option.key === this.currentRole);
  }

  @action
  handleChange(option: Option | null | undefined): void {
    if (option) {
      this.localRole = option.key as AccessRight;
      this.args.row.onRoleChange?.(option.key as AccessRight);
    }
  }

  <template>
    <div class={{styles.container}}>
      <PrismSelectInput
        @disabled={{@row.isDisabled}}
        @isSmall={{true}}
        @onChange={{this.handleChange}}
        @options={{this.options}}
        @unsafe_matchTriggerWidth={{true}}
        @value={{this.selectedOption}}
        data-test-id="cell-role-select"
      />
    </div>
  </template>
}
